import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportResponseService {
  private apiUrl = environment.apiUrl + '/report_responses/';  // Usa la variable global
  private http = inject(HttpClient); // Inyección sin constructor

  private dataToEdit = new BehaviorSubject<any>('');
  dataToEdit$ = this.dataToEdit.asObservable()

  private selectedReportResponseId = new BehaviorSubject<string>(''); // Estado reactivo
  selectedReportResponseId$ = this.selectedReportResponseId.asObservable(); // Observable para escuchar cambios

  private isforEditReport = new BehaviorSubject<boolean>(false);
  isforEditReport$ = this.isforEditReport.asObservable(); // Observable para escuchar cambios
  setIsforEditReport(isforEdit: boolean): void {
    this.isforEditReport.next(isforEdit); // Actualiza el valor globalmente
  }

  setSelectedReportResponseId(reportResponseId: string): void {
    this.selectedReportResponseId.next(reportResponseId); // Actualiza el valor globalmente
  }
  getSelectedReportResponseId(): string {
    return this.selectedReportResponseId.value; // Obtiene el valor actual
  }
  setDataToEdit(data: any) {
    this.dataToEdit.next(data)
  }

  get(periodId?: String, userId?: String): Observable<any> {
    let httpParams = new HttpParams();
    if (periodId) httpParams = httpParams.set('periodId', periodId.toString());
    if (userId) httpParams = httpParams.set('userId', userId.toString());
    return this.http.get(`${this.apiUrl}get`, { params: httpParams });
  }

  getView(params: { page?: number; limit?: number, username?: string, periodId?: string, licenseId?: string, stateId?: string }): Observable<any> {
    let httpParams = new HttpParams();
    if (params.page) {
      httpParams = httpParams.set('page', params.page.toString());
    }
    if (params.limit) {
      httpParams = httpParams.set('limit', params.limit.toString());
    }
    if (params.username) {
      httpParams = httpParams.set('username', params.username);
    }
    if (params.periodId) {
      httpParams = httpParams.set('periodId', params.periodId);
    }
    if (params.licenseId) {
      httpParams = httpParams.set('licenseID', params.licenseId);
    }
    if (params.stateId) {
      httpParams = httpParams.set('stateId', params.stateId);
    }
    return this.http.get(`${this.apiUrl}getView`, { params: httpParams });
  }

  getViewNoPagination(periodId: string, userId?: string, stateId?: string): Observable<any> {
    let httpParams = new HttpParams();
    if (periodId) {
      httpParams = httpParams.set('periodId', periodId);
    }
    if (userId) {
      httpParams = httpParams.set('userId', userId);
    }
    if (stateId) {
      httpParams = httpParams.set('stateId', stateId);
    }
    return this.http.get(`${this.apiUrl}getViewNoPagination`, { params: httpParams });
  }

  downloadPDF(periodId: string): Observable<Blob> {
    let httpParams = new HttpParams();
    if (periodId) {
      httpParams = httpParams.set('periodId', periodId);
    }
    return this.http.get(`${this.apiUrl}generatePdf`, { params: httpParams, responseType: 'blob' });
  }

  downloadExcel(periodId: string, stateId: string): Observable<Blob> {
    let httpParams = new HttpParams();
    if (periodId) {
      httpParams = httpParams.set('periodId', periodId);
    }
    if (stateId) {
      httpParams = httpParams.set('stateId', stateId);
    }
    return this.http.get(`${this.apiUrl}generateExcel`, { params: httpParams, responseType: 'blob' });
  }

  getById(id: string): Observable<any> {
    return this.http.get(this.apiUrl + 'getById/' + id)
  }

  getCurrentState(id: string): Observable<any> {
    return this.http.get(this.apiUrl + 'getCurrentState/' + id)
  }

  getTotalsReport(id: string): Observable<any> {
    return this.http.get(this.apiUrl + 'getTotalsReport/' + id)
  }

  update(id: string, userData: any): Observable<any> {
    return this.http.put(this.apiUrl + 'update/' + id, userData);
  }

  updateStateInReview(id: string, reviewerComment: string): Observable<any> {
    return this.http.put(this.apiUrl + 'updateStateInReview/' + id, { reviewerComment });
  }
  updateStateInAccept(id: string, reviewerComment: string): Observable<any> {
    return this.http.put(this.apiUrl + 'updateStateInAccept/' + id, { reviewerComment });
  }
  updateStateInReject(id: string, reviewerComment: string): Observable<any> {
    return this.http.put(this.apiUrl + 'updateStateInReject/' + id, { reviewerComment });
  }
  updateStateCorrection(id: string, reviewerComment: string): Observable<any> {
    return this.http.put(this.apiUrl + 'updateStateCorrection/' + id, { reviewerComment });
  }

  save(userData: any): Observable<any> {
    return this.http.post(this.apiUrl + 'save/', userData);
  }

  generateResumeDependents(periodId:string): Observable<Blob> {
    const httpParams = new HttpParams().set('periodId', periodId);
    return this.http.get(`${this.apiUrl}generateResumeDependents`, {params:httpParams, responseType: 'blob' });
  }

  generateResumeIndependents(periodId: string): Observable<Blob> {
    const httpParams = new HttpParams().set('periodId', periodId);
    return this.http.get(`${this.apiUrl}generateResumeIndependents`, { params: httpParams, responseType: 'blob' });
  }

}

